import { sanitizeBotFilename } from './filename.ts';

export const MAX_BOT_NAME_LENGTH = 80;
export const UNTITLED_BOT_NAME = 'Untitled';

/** Display title stored on the profile. The file stem is separate. */
export function sanitizeBotName(raw: string): string {
  return raw
    .replace(/[\u0000-\u001f\u007f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, MAX_BOT_NAME_LENGTH);
}

export function botDisplayName(name: string, fallback = UNTITLED_BOT_NAME): string {
  return name.trim() || fallback;
}

/** Catalog fallback when `name` is empty: `late-braker` → `Late Braker`. */
export function labelFromBotFilename(fileName: string): string {
  const stem = fileName.replace(/\.json$/i, '');
  return stem.replace(/[-_]+/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}

/** Turns a title into a catalog basename, or null if nothing safe remains. */
export function suggestBotFilename(raw: string): string | null {
  const slug = sanitizeBotName(raw)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 128);

  return slug ? sanitizeBotFilename(slug) : null;
}
